import { Accordion, AccordionDetails, AccordionSummary, Grid, SxProps, Table, TableBody, TableCell, TableHead, TableRow, Theme, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CorrectedRow, CouponShare } from "../models/couponshares";
import { DetailedRound } from "../models/round";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { correctRows } from "../common/rowUtil";


function RowsStatistics({ round, couponShare }: { round: DetailedRound, couponShare: CouponShare }) {

    function groupBy<
        K extends "numCorrect" | "numCorrectCompleted" | "numCorrectStarted" | "numPotential"
    >(
        xs: CorrectedRow[],
        key: K
    ): Record<number, CorrectedRow[]> {
        return xs.reduce((acc, item) => {
            const groupKey = item[key];
            (acc[groupKey] = acc[groupKey] || []).push(item);
            return acc;
        }, {} as Record<number, CorrectedRow[]>);
    }

    const { t } = useTranslation();

    const styleComponent: SxProps<Theme> = {
        background: "var(--background_3)"
    };

    const styleTextColumn: SxProps<Theme> = {
        fontSize: "12px",
        color: "var(--text-black-dark-background)",
        padding: "5px 14px 5px 14px"
    };

    const styleTextHeader: SxProps<Theme> = {
        fontSize: "12px",
        color: "var(--text-black-dark-background)",
        padding: "5px 14px 5px 14px",
        fontWeight: "bold"
    };

    let myRows: any[] = [];
    let correctedRows: CorrectedRow[] = [];
    let groupedByCorrect: Record<number, CorrectedRow[]> = {};
    let groupedByCompleted: Record<number, CorrectedRow[]> = {};
    let groupedByStarted: Record<number, CorrectedRow[]> = {};
    let groupedByPotential: Record<number, CorrectedRow[]> = {};

    if (round === undefined || couponShare === undefined)
        return <></>;

    const bets = couponShare?.coupon?.coupon?.bets;

    if (bets?.length) {

        bets.forEach(bet => {
            myRows = myRows.concat(bet.rows);
        });

        correctedRows = correctRows(myRows, round, false);
        groupedByCorrect = groupBy(correctedRows, 'numCorrect');
        groupedByCompleted = groupBy(correctedRows, 'numCorrectCompleted');
        groupedByStarted = groupBy(correctedRows, 'numCorrectStarted');
        groupedByPotential = groupBy(correctedRows, 'numPotential');
    }


    return (

        <Accordion sx={styleComponent}>
            <AccordionSummary
                expandIcon={<ArrowDropDownIcon sx={{ color: "var(--text-black-dark-background)" }} />}
                aria-controls="panel1-content"
                id="panel1-header">
                <Typography sx={{ color: "var(--text-black-dark-background)" }}>{t('row_statistics')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container justifyContent="center" alignItems="center">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={styleTextHeader}>{t('correct_rows')}</TableCell>
                                <TableCell sx={styleTextHeader}>{t('your_rows')}</TableCell>
                                <TableCell sx={styleTextHeader}>{t('started_games')}</TableCell>
                                <TableCell sx={styleTextHeader}>{t('finished')}</TableCell>
                                <TableCell sx={styleTextHeader}>{t('potential')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.from({ length: round.fixtures.length + 1 }, (_, j) => round.fixtures.length - j).map((i) => {

                                let isSecond = ((i + 1) % 2) === 0;

                                let numOwn = 0;
                                let numOwnComplete = 0;
                                let numOwnStart = 0;
                                let numPotential = 0;

                                if (groupedByCorrect[i]) {
                                    numOwn = groupedByCorrect[i].length;
                                }
                                if (groupedByCompleted[i]) {
                                    numOwnComplete = groupedByCompleted[i].length;
                                }
                                if (groupedByStarted[i]) {
                                    numOwnStart = groupedByStarted[i].length;
                                }
                                if (groupedByPotential[i]) {
                                    numPotential = groupedByPotential[i].length;
                                }

                                return (
                                    <TableRow key={`${i} payout row`}>
                                        <TableCell sx={styleTextColumn}>{i}</TableCell>
                                        <TableCell sx={styleTextColumn}>{numOwn} {t('st')}</TableCell>
                                        <TableCell sx={styleTextColumn}>{numOwnStart} {t('st')}</TableCell>
                                        <TableCell sx={styleTextColumn}>{numOwnComplete} {t('st')}</TableCell>
                                        <TableCell sx={styleTextColumn}>{numPotential} {t('st')}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default RowsStatistics;